import { PublicLayout } from "./layouts/PublicLayout";
import { PrivateLayout } from "./layouts/PrivateLayout";
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './styles/global.css'
import './styles/variables.css'
import { Login } from "./components/user/auth/login/pages/Login/Login";
import { Register } from "./components/user/auth/register/pages/Register/Register";
import { VimeoComponent } from "./components/vimeo/Vimeo";
import { CompletedForm } from "./components/feedback/pages/CompletedForm";
import { Biblioteca } from "./components/bibloteca/Biblioteca";
import { Collections } from "./components/collections/Collections"
import { AuthProvider } from "./context/Authcontext";
import ProtectedRoute from "./layouts/ProtectedRoute";
import { Registration } from "./components/user/auth/Registration/pages/Application";
import { RecoverPassword } from "./components/user/auth/recover/recoverPassword/pages/RecoverPassword";
import { Training } from "./components/training/Training";
import { ToggleProvider } from "./context/toggle/toggleBtn";
import { Avisos } from "./components/avisos/Avisos";
import { Profile } from "./components/user/profile/Profile";
import { Unsubscribe } from "./pages/Unsubscribe/Unsubscribe";



function App() {
  return (


    <>
      <ToggleProvider>
        <AuthProvider>

          <BrowserRouter>
            <Routes>

              <Route element={<PublicLayout />}>


                {/* Ruta por defecto 👇*/}
                <Route path="*" element={<Login />}></Route>

                <Route path="/login" element={<Login />}></Route>

                <Route path="/formulario-interes" element={<Register />}></Route>

                <Route path="/formulario-inscripcion/:enrollmentId" element={<Registration />} />

                <Route path="/vimeo/:videoId" element={<VimeoComponent />} ></Route>

                <Route path="/completed-form" element={<CompletedForm />} ></Route>

                <Route path="/recuperar-password/:transactionId" element={<RecoverPassword />}></Route>

                <Route path="/Unsuscribe/:email" element={<Unsubscribe />}></Route>

              </Route>



              <Route
                element={
                  <ProtectedRoute>
                    <PrivateLayout />
                  </ProtectedRoute>
                }
              >
                <Route path="/biblioteca" element={<Biblioteca />} />
                <Route path="/videos/:collectionId" element={<Collections />} />
                <Route path="/training" element={<Training />} />
                <Route path="/avisos/:avisoId" element={<Avisos />} />
                <Route path="/profile" element={<Profile />} />
              </Route>

            </Routes>

          </BrowserRouter>

        </AuthProvider>
      </ToggleProvider>
    </>


  );
}

export default App;
